<div class="unit-set-detail">
  <div class="unit-set-detail__header">
    <button mat-button (click)="back.emit()">&larr; Back to Unit Sets</button>
    <strong class="unit-set-detail__title">{{ unitSetName }} — Units</strong>
  </div>

  <wc-grid gridKey="modelsUnits" [context]="gridContext" [showQuickSearch]="true"></wc-grid>
</div>
